<template>
  <div class="page">
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="secondary" dark class="py-4 px-2">
        <v-progress-linear indeterminate color="primary" class></v-progress-linear>
      </v-card>
    </v-dialog>

    <page-view v-model="page"></page-view>
  </div>
</template>

<script>
import Page from "@/components/page";

export default {
  name: "Page",
  components: {
    pageView: Page
  },
  data() {
    return {
      loading: false,
      page: { sections: [] }
    };
  },
  beforeRouteUpdate() {
    this.load();
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      console.log("this.$route.params.slug ", this.$route.params.slug);
      try {
        this.page = await this.$api(`/pages`);
      } catch (ex) {
        console.log("ex", ex);
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.page {
  min-height: 80vh;
}
</style>